import { create } from 'zustand';

export interface ArticleStoreProps {
    activeArticle: any;
    tutorials: { allArticles: any[]; trendingArticles: any[] };
    blog: { allArticles: any[]; trendingArticles: any[] };
    catalog: { allArticles: any[]; trendingArticles: any[] };
    cheatsheet: { allArticles: any[]; trendingArticles: any[] };
    doc: { allArticles: any[]; trendingArticles: any[] };
    examples: { allArticles: any[]; trendingArticles: any[] };
}

export const useArticleStore = create<ArticleStoreProps>(() => ({
    activeArticle: {},
    tutorials: { allArticles: [], trendingArticles: [] },
    blog: { allArticles: [], trendingArticles: [] },
    catalog: { allArticles: [], trendingArticles: [] },
    cheatsheet: { allArticles: [], trendingArticles: [] },
    doc: { allArticles: [], trendingArticles: [] },
    examples: { allArticles: [], trendingArticles: [] },
}));
